module.exports = __webpack_public_path__ + "static/media/ils_digilocker_success.fc935643.svg";